import { Swiper, Pagination, Autoplay } from "swiper/bundle";
export default class Swiper1 {
    constructor() {
        console.log('%c👍🏼 Swiper 1', 'color: yellow');
        
        this.swiper1 = document.querySelectorAll(
            '.swiper--1'
        ) 
    }
    init() {
        this.swiper1 .forEach((elem, i) => {
            
            let swiper;
            let init = false;
            let wrapper = elem.querySelector('.swiper-wrapper');
            let onresize = function (e) {
                if (window.innerWidth > 576) {
                    if (!init) {
                        init = true;
                        wrapper.classList.remove('row');
                        swiper = new Swiper(elem, {
                        slidesPerView: 1.3,
                        loop: true,
                        spaceBetween: 10,
                        speed: 2000,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: true
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 1.16,
                            },
                            992: {
                                slidesPerView: 1.3,
                            }
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true
                        },
                    });   

                    } 
                } else if (init) {
                    swiper.destroy();
                    init = false;
                }
            }
            onresize();
            window.addEventListener("resize", onresize);
        })
    }
}